<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios'; 
import Swal from "sweetalert2";

export default {
  page: {
    title: "Pending Payment",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "Pending Payment",
      items: [
        {
          text: "Order",
          href: "/",
        },
        {
          text: "Pending Payment",
          active: true,
        },
      ],
        //detail order list
        OrderList:[],
        DevicesDetail:[],
        //end of detail order list

        //wiget spinner
        OrderSeen:true,
        OrderSeenSummery:true,
        //end of wiget spinner

        //hide and show
        UploadSuccessfullSeen:false,


        staticURLDownload: process.env.VUE_APP_API_BASEURL,
        s3bucket: process.env.VUE_APP_BUCKET,
        

        TotalAmount:0,  //final amount after grading or not

    };
  },

    methods: {
        getOrderDetails(){
            this.staticURLDownload = this.staticURLDownload.replace('/api','');
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'grading/'+this.$route.params.OrderId)
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.OrderSeen = false;
                    }else{
                        this.OrderList = response.data['0'];
                        console.log(this.OrderList);
                        this.OrderSeen = false;
                        
                        this.TotalAmount = this.OrderList.totalQuotation; //final amount
                        
                        this.items['2'].text = this.OrderList.Order_id;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderSeen = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
            });
        },

        getSummeryDevice(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/grading/'+this.$route.params.OrderId)
            .then(response => {
                
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.OrderSeenSummery = false;
                    }else{
                        this.DevicesDetail = response.data;
                        this.OrderSeenSummery = false;
                        
                        this.TotalAmount = this.OrderList.totalQuotation; //final amount
                        
                        this.items['2'].text = this.OrderList.Order_id;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderSeenSummery = false;
                }
                
            })
            .catch(error => {
                this.messageBag = [error.error];
                this.OrderSeen = false;
            });
        },

        ConfirmPayment() {
            Swal.fire({
                title: "<i>Complete Order</i>",
                imageUrl: require("@/assets/images/credit-card 1.png"),
                html:
                "Are you sure you want to complete your order?",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success me-2",
                cancelButtonClass: "btn btn-danger",
                buttonsStyling: false,
                confirmButtonText:
                'Yes',
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "7" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+this.$route.params.OrderId, posting_)
                    .then(response => {
                        if (response) {
                            this.getOrderDetails();
                            this.getSummeryDevice();
                            Swal.fire("Order Completed");
                        }else{
                            Swal.fire("Fail!", "Fail Complete Order", "fail");
                        }
                    });
                    this.ButtonSeen=false;
                }
            });
        },

        submitFile() {
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);


            const headers = { 'Content-Type': 'multipart/form-data' };
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/uploadpayment/'+this.$route.params.OrderId, formData, 
                { headers }
            ).then((res) => {
                    this.DevicesUpload ='';
                    // console.log(res.data);
                    // console.log(res.data.id);

                    if(res.data.status=='error'){
                        this.messageBag = res.data.msj;
                        this.isLoadingListDevices = false;
                        this.getUploadDevicesSeen = false;
                    }else{
                        this.UploadSuccessfullSeen=true;
                        this.getOrderDetails();
                        this.getSummeryDevice();
                    }
                    
                }
            );
        },

        uploadFile() {
            this.Images = this.$refs.file.files[0];
        },
        
    },

    mounted() {
        if(this.role != 3){
            this.getOrderDetails();
            this.getSummeryDevice();
        }else{
            alert('You are not authorized to view the requested page!')
        }
    },

  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div v-if='OrderSeen'>
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <div class="card">                        
                        <div class="card-body">
                            <br>
                            <div class="row align-items-center g-12">
                                <div class="col-lg-12">

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <table>
                                                <tr>
                                                    <td><p class="fs-6"><b>Person In Charge</b></p></td>
                                                    <td><p class="fs-6"> {{ OrderList.user }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Company Name</b></p></td>
                                                    <td><p class="fs-6"> {{ OrderList.Company }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6"><b>Company Address</b></p></td>
                                                    <td><p class="fs-6"> {{ OrderList.Address }} </p></td>
                                                </tr>

                                                <tr>
                                                    <td style="vertical-align:top;">
                                                       <p class="fs-6"><b> Invoice</b></p>
                                                    </td>
                                                    <td>
                                                        <span v-if="OrderList.invoice_tax_file == NULL || OrderList.invoice_tax_file == '' ">
                                                            <p class="fs-6">Tax N/A</p>
                                                        </span>
                                                        <span v-else>
                                                            <!-- excel/qc/186 -->
                                                            <p class="fs-6">
                                                                <a :href="OrderList.invoice_tax_file" target="_blank" >View TAX</a>
                                                            </p>
                                                        </span>

                                                        
                                                        <span v-if="OrderList.jompay_file == NULL || OrderList.jompay_file == ''">
                                                            <p class="fs-6">JomPay N/A</p>
                                                        </span>
                                                        <span v-else>
                                                            <!-- excel/qc/186 -->
                                                            <p class="fs-6">
                                                                <a :href="OrderList.jompay_file" target="_blank" >View Jompay</a>
                                                            </p>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td>
                                                       <p class="fs-6"><b> Download Excel </b></p>
                                                    </td>
                                                    <td>
                                                        <p class="fs-6"> <a :href="staticURLDownload+OrderList.URLFile" >Download File</a></p>
                                                    </td>
                                                </tr> -->

                                                <tr v-if="OrderList.proving_payment">
                                                    <td>
                                                       <p class="fs-6"><b> Proof of Payment </b></p>
                                                    </td>
                                                    <td>
                                                        <p class="fs-6"> <a :href="s3bucket+OrderList.proving_payment" target="_blank">View File</a></p>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-lg-6">
                                            <table>
                                                <tr>
                                                    <td><p class="fs-6">&emsp;<b>No. of Devices</b></p></td>
                                                    <td><p class="fs-6">&emsp;{{ OrderList.quantity }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6">&emsp;<b>Total Amount</b></p></td>
                                                    <td><p class="fs-6">&emsp;{{ OrderList.currency }} {{ TotalAmount }}</p></td>
                                                </tr>

                                                <tr>
                                                    <td><p class="fs-6">&emsp;<b>Status</b></p></td>
                                                    <td><p class="fs-6">&emsp;{{ OrderList.Status }}</p></td>
                                                </tr>
                                                <tr>
                                                    <td><p class="fs-6">&emsp;<b>Conditional Quotation</b></p></td>
                                                    <td>
                                                        <router-link :to="'/order/cq/'+OrderList.id"> <p class="fs-6">&emsp;{{ OrderList.quotation_number }}</p> </router-link>
                                                        <!-- <p class="fs-6">&emsp; <a @click="viewconditionquotation()"> {{ OrderList.quotation_number }}</a> </p> -->
                                                    </td>
                                                </tr>

                                                <tr v-if="OrderList.po_number">
                                                    <td><p class="fs-6">&emsp;<b> PO No.</b></p></td>
                                                    <td>
                                                        <router-link :to="'/order/po/'+OrderList.id"> <p class="fs-6">&emsp;{{ OrderList.po_number }}</p> </router-link>
                                                        <!-- <p class="fs-6">&emsp; <a @click="viewconditionquotation()"> {{ OrderList.quotation_number }}</a> </p> -->
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-lg-6" v-if="OrderList.StatusId=='6'||OrderList.StatusId=='7'">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <p class="fs-6"><b> Upload Payment/Receipt</b></p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="input-group ">
                                                            <input type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload">
                                                            <button class="btn btn-outline-success" type="button" id="inputGroupFileAddon04" @click="submitFile">Upload</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                            <div class="alert alert-success alert-dismissible fade show" v-if="UploadSuccessfullSeen" role="alert">
                                                <strong>Success Upload </strong> 
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div>
                                        </div>
                                        <div class="col-lg-6" v-if="OrderList.StatusId=='6'">
                                            <table>
                                                <tr>
                                                    <td> <br><br>
                                            <button class="btn btn-success ss waves-effect waves-light" type="button" id="inputGroupFileAddon04" @click="ConfirmPayment">Complete Order</button>
                                            </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">  
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">Quotation Upon CompAsia assessment</h4>
                        </div>                      
                        <div class="card-body">
                            <br>
                            <ul class="nav nav-tabs mb-3" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" data-bs-toggle="tab" href="#Summary" role="tab" aria-selected="false">
                                        Summary Order
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" href="#detailOrder" role="tab"
                                        aria-selected="false">
                                        Detail Order
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content  text-muted">
                                <div class="tab-pane active" id="Summary" role="tabpanel">
                                           
                                    <div class="table-responsive table-card">
                                        <table class="table align-middle table-nowrap mb-0">
                                            <thead >
                                                <tr>
                                                    <th scope="col">No</th>
                                                    <th scope="col">Model</th>
                                                    <th scope="col">Brand Name</th>
                                                    <th scope="col">Storage</th>
                                                    <th scope="col">Grading</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">Unit Price</th>
                                                    <th scope="col">Total Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in DevicesDetail" :key="index" class="content">
                                                    <td>{{ index+1 }}</td>
                                                    <td>{{ item.model }}</td>
                                                    <td>{{ item.brand }}</td>
                                                    <td>{{ item.storage }}</td>
                                                    <td>{{ item.name }}</td>
                                                    <td>{{ item.total }}</td>
                                                    <td>{{ OrderList.currency }} {{ item.price.toLocaleString('en-US') }}</td>
                                                    <td>{{ OrderList.currency }} {{ item.priceing.toLocaleString('en-US') }}</td>
                                                </tr>
                                                <tr v-if='isLoadingCalculateAllPrice'>
                                                    <td colspan="7">
                                                        <div class="spinner-border text-success" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-else>

                                                    <td colspan="6"> </td>
                                                    <td style="vertical-align: top;">
                                                        <p class="text-right"> <b>Total</b></p>
                                                        
                                                    </td>
                                                    <td>
                                                        <p class="text-right">{{ OrderList.currency }} {{ OrderList.totalQuotation.toLocaleString('en-US') }}</p>
                                                        <!-- <button class="btn btn-success ss waves-effect waves-light" type="button" id="inputGroupFileAddon04" @click="ConfirmPayment">Confirm Payment</button> -->
                                                    </td>
                                                </tr>
                                           
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                <div class="tab-pane" id="detailOrder" role="tabpanel">
                                    <div class="row align-items-center g-12">
                                        <div class="col-lg-12">
                                            <div class="table-responsive table-card">
                                                <table class="table align-middle table-nowrap mb-0">
                                                    <thead >
                                                        <tr>
                                                            <th scope="col">NO.</th>
                                                            <th scope="col">MODEL</th>
                                                            <th scope="col">BRAND NAME</th>
                                                            <th scope="col">CAPACITY</th>
                                                            <th scope="col">IMEI</th>
                                                            <th scope="col">GRADING</th>
                                                            <th scope="col">PRICE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in OrderList.devices" :key="index" class="content">
                                                            <td>{{ index+1 }}</td>
                                                            <td>{{ item.model }}</td>
                                                            <td>{{ item.brand }}</td>
                                                            <td>{{ item.storage }}</td>
                                                            <td>{{ item.imei }}</td>
                                                            <td>{{ item.condition }}</td>
                                                            <td>{{ OrderList.currency }} {{ item.price }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="5"> </td>
                                                            <td colspan="1" style="vertical-align: top;">
                                                                <p class="fs-6 text-right">&emsp;<b>Total</b></p>
                                                            </td>
                                                            <td >
                                                                <b> {{ OrderList.currency }} {{ OrderList.totalQuotation }}</b>
                                                                <br><br>
                                                                <!-- <button class="btn btn-success ss waves-effect waves-light" type="button" id="inputGroupFileAddon04" @click="ConfirmPayment">Confirm Payment</button> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>